import { cncMiniLazyload } from '@default/scripts/modules/lazy-load/cncMiniLazyload';
import './components/galleryLayerRecommendedArticles';

/** Zpracovava lazyloading obrazku */
cncMiniLazyload();

/**
 *  GalleryLayerRecommendedArticles
 */
export const dynamicGalleryLayerRecommendedArticles = async () => {
    const trigger = document.querySelector('template[data-gallery-layer-recommended-articles]');

    if (trigger) {
        const { AddGalleryLayerRecommendedArticles } = await import(
            /* webpackChunkName: 'galleryLayerRecommendedArticles' */
            './components/galleryLayerRecommendedArticles'
        );

        AddGalleryLayerRecommendedArticles(trigger);
    }
};

/** Spusteni dynamickych importu */
const loadDynamicImports = () => {
    dynamicGalleryLayerRecommendedArticles();
};

loadDynamicImports();
